import React, { useMemo } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Coffee, Eye, Sparkles } from "lucide-react";

const NUDGES = [
  {
    icon: Eye,
    title: "Time to blink your eyes!",
    body: "You've been laser-focused for a while. Close your eyes for 20 seconds and let them rest — your parks aren't going anywhere.",
  },
  {
    icon: Coffee,
    title: "Coffee break, Commander?",
    body: "10 minutes of pure focus deserves a small reward. Stretch, sip something warm, and come back sharper.",
  },
  {
    icon: Sparkles,
    title: "Posture check!",
    body: "Roll your shoulders. Straighten that back. Look 20 feet away for 20 seconds. The dashboard will wait.",
  },
  {
    icon: Eye,
    title: "Your screen misses you... not.",
    body: "Step away for a moment. Hydrate. Breathe. Industrial parks are best monitored by a refreshed mind.",
  },
];

export function WellnessModal({ open, onClose }) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const nudge = useMemo(() => NUDGES[Math.floor(Math.random() * NUDGES.length)], [open]);
  const Icon = nudge.icon;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose?.(); }}>
      <DialogContent className="sm:max-w-md" data-testid="wellness-modal">
        <DialogHeader>
          <div className="mx-auto mb-2 grid h-14 w-14 place-items-center rounded-full bg-amber-100 text-amber-600">
            <Icon className="h-7 w-7" />
          </div>
          <DialogTitle className="text-center text-xl" data-testid="wellness-modal-title">
            {nudge.title}
          </DialogTitle>
          <DialogDescription className="text-center text-base leading-relaxed pt-1">
            {nudge.body}
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-md bg-muted/60 px-3 py-2 text-center text-xs text-muted-foreground">
          Tip: The 20-20-20 rule — every 20 minutes, look 20 feet away for 20 seconds.
        </div>
        <DialogFooter className="sm:justify-center">
          <Button
            onClick={onClose}
            className="bg-amber-500 hover:bg-amber-600 text-slate-900"
            data-testid="wellness-modal-close"
          >
            Okay, I'm refreshed!
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default WellnessModal;
